module.exports = __webpack_public_path__ + "media/images/official/about_yamori_mojikoua-1b5603cdbca5fddb6ed8bce9d5d02f8f.jpg";